import Paper from "@mui/material/Paper";
import {
    Autocomplete,
    Button, IconButton,
    List,
    ListItemButton,
    ListItemText,
    Popover,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
//import {makeStyles} from '@material-ui/core/styles';

import React, {memo, useCallback, useEffect, useMemo, useRef, useState} from "react";
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {useDispatch, useSelector} from "react-redux";
import {
    deleteJob,
    pushDetail,
    setCatalogJobsDetailName,
    setCustomJobsDetailName,
    setDetailCustomVatValue,
    setDetailHidden
} from "../../redux/jobsSlice";
import debounce from "../../utils/debounce";
import {abcParts} from "../../serverREST";
import {setAllDetails} from "../../redux/listsSlice";
import {
    setDetailAmount,
    setDetailPrice
} from "../../redux/jobsSlice";
import {
    detailsAmountSum,
    detailsFinalSum,
    detailsFinalVat,
    detailSum,
    detailVat,
    filterDetailsFromJobs,
    vatString
} from "./TableSums";
import {VATs} from "../../redux/settingsSlice";
import {NumericField} from "./NumberField";

function CustomDetail({detail, index, detailPriceField}) {
    const allDetails = useSelector(state => state.lists.allDetails);
    const dispatch = useDispatch()

    const debounceSearch = useMemo(
        () =>
            debounce(async (value) => {
                try {
                    await abcParts(value, true);
                } finally {
                   // setLoading(false);
                }
            }, 500),
        [abcParts]
    );

    useEffect(() => {
        return () => {
            debounceSearch.cancel();
        };
    }, [debounceSearch]);

    return (
        <Autocomplete
            // filterOptions={filterOptions}
            filterOptions={(options, state) => options}
            style={{flexGrow: 1}}
            freeSolo
            multiline="true"
            value={detail}
            groupBy={(option) => option.system_name}
            filterSelectedOptions
            noOptionsText={'Ничего не найдено'}
            onChange={(event, newValue) => {
                if (newValue) {
                    dispatch(setCatalogJobsDetailName({...newValue, index: index}))
                    detailPriceField.current.focus()
                } else {
                    dispatch(setCustomJobsDetailName(
                        {
                            index: index,
                            part_name: '',
                        }))
                    dispatch(setAllDetails([]))
                }
            }}
            getOptionLabel={(option) => option.part_name}
            options={allDetails}
            renderInput={(params) =>
                <TextField {...params}
                           sx={{
                               "& .MuiInputBase-input::placeholder": {color: "red"},
                           }}
                           error={detail.part_name === ''}
                           placeholder="Выберите деталь/жидкость"
                           onChange={(event) => {
                               if (event.target.value !== '') {
                                   debounceSearch(event.target.value)
                               }

                               dispatch(setCustomJobsDetailName(
                                   {
                                       index: index,
                                       part_name: event.target.value,
                                   }))
                           }}
                           onFocus={(event) => {
                               dispatch(setAllDetails([]))

                               if (event.target.value !== '') {
                                   debounceSearch(event.target.value)
                               }
                           }}
                           multiline
                           variant={'outlined'}
                           size={'small'}
                />
            }
        >
        </Autocomplete>
    )
}
/*
const useStyles = makeStyles({
    input: {
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },
});
*/
function ContentRow({detail, index, isEdit}) {
    const dispatch = useDispatch();
   // const noArrowClass = useStyles();
    const detailAmountField = useRef();
    const detailPriceField = useRef();

    const partsVat = useSelector(state => state.settings.vats[VATs.parts]);
    const showVat = partsVat.active;

    return (
        <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
            <TableCell>
                {detail.detailOnly ?
                    <CustomDetail detail={detail} index={index} detailPriceField={detailPriceField}/>
                    :
                    detail.part_name
                }
            </TableCell>
            <TableCell>
                <NumericField
                    disabled={!isEdit}
                    inputRef={detailPriceField}
                   /* className={noArrowClass.input}*/
                    sx={{
                        '& input[type=number]': {
                            MozAppearance: 'textfield',
                        },
                        '& input[type=number]::-webkit-outer-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                        },
                        '& input[type=number]::-webkit-inner-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                        },
                    }}
                    size="small"
                    variant={'outlined'}
                    value={detail.price}
                    InputProps={{inputProps: {min: 0, max: 1000000000, autoComplete: 'off'}}}
                    emptyValue={0}
                    showEmptyValue
                    allowNegative={false}
                    decimalScale={2}
                    fixedDecimalScale
                    onValueChange={(value) => {
                        dispatch(setDetailPrice({index: index, price: value}))
                    }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            detailAmountField.current.focus()
                        }
                    }}
                />
            </TableCell>
            <TableCell>
                <NumericField
                    inputRef={detailAmountField}
                    size="small"
                    disabled={!isEdit}
                    variant={'outlined'}
                    value={detail.amount}
                    InputProps={{inputProps: {min: 0, max: 1000000000, autoComplete: 'off'}}}
                    emptyValue={0}
                    showEmptyValue
                    allowNegative={false}
                    decimalScale={2}
                    onValueChange={(value) => {
                        dispatch(setDetailAmount({index: index, amount: value}));
                    }}
                />
            </TableCell>
            {showVat &&
                <TableCell>
                    <DetailVatButton
                        isEdit={isEdit}
                        detail={detail}
                        detailIndex={index}
                    />
                </TableCell>
            }
            <TableCell>
                {detailSum(detail, {useVat: true}).toFixed(2)}
            </TableCell>
            <TableCell style={{width: '2em'}}>
                {isEdit ? <IconButton
                    disabled={detail.hidden}
                    size="medium"
                    edge="start"
                    color="secondary"
                    aria-label="menu"
                    onClick={() => {
                        if (detail.detailOnly) {
                            dispatch(deleteJob(index));
                        } else {
                            dispatch(setDetailHidden({index: index, hidden: true}));
                        }
                    }}
                >
                    <DeleteIcon/>
                </IconButton> : null}
            </TableCell>
        </TableRow>
    )
}

function DetailsFooter({showVat}) {
    return (
        <>
            <TableCell variant={'head'} size={'small'}>
                {`Итого: ${detailsAmountSum()}`}
            </TableCell>
            {Boolean(showVat) &&
                <TableCell variant={'head'} size={'small'}>
                    {detailsFinalVat().toFixed(2)}
                </TableCell>
            }
            <TableCell variant={'head'} size={'small'}>
                {detailsFinalSum({useVat: true}).toFixed(2)}
            </TableCell>
        </>
    )
}

function DetailVatButton({isEdit = true,detail, detailIndex}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const partsVat = useSelector(state => state.settings.vats[VATs.parts]);
    const dispatch = useDispatch();

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleSelect = (option) => {
        const newValue = option === partsVat.value ? null : option;

        dispatch(setDetailCustomVatValue({index: detailIndex, value: newValue}));
    };

    let options = Array.from(new Set([...partsVat.options, partsVat.value]));
    options = options.sort((a, b) => b - a);

    if (options.length > 1) {
        options = options.filter(v => {
            const hasCustomValue = detail.custom_vat_value !== null && detail.custom_vat_value !== undefined;

            return v !== (hasCustomValue ? detail.custom_vat_value : partsVat.value);
        });
    }

    const isSingleOption = options.length === 1;
    const isOpen = Boolean(anchorEl);

    const buttonSx = {
        height: 40,
        pr: 1,
        color: 'rgba(0, 0, 0, 0.6)',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.87)',
            backgroundColor: 'transparent',
        },
        transition: 'color 10ms, border-color 10ms, background-color 10ms',
    };

    return (
        <React.Fragment>
            <Button
                sx={buttonSx}
                disabled={!isEdit}
                variant="outlined"
                onClick={(e) => isSingleOption ? handleSelect(options[0]) : handleOpen(e)}
                endIcon={isOpen ? <ExpandLess/> : <ExpandMore/>}
            >
                {vatString(detailVat(detail))}
            </Button>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{elevation: 2}}
            >
                <List sx={{p: 0}}>
                    {options.map((option, index) => (
                        <ListItemButton
                            key={index}
                            onClick={() => {
                                handleSelect(option);
                                handleClose();
                            }}
                        >
                            <ListItemText primary={`${option}%`}/>
                        </ListItemButton>
                    ))}
                </List>
            </Popover>
        </React.Fragment>
    );
}

const MemoizedRow = memo(ContentRow);

export default function DetailsTable({workID}) {
    const jobs = useSelector(state => state.jobs.jobs);
    const details = filterDetailsFromJobs(jobs, false);

    const partsVat = useSelector(state => state.settings.vats[VATs.parts]);
    const showVat = partsVat.active;
    const WorkFlag = useSelector(state => state.settings.editWorkOrder);

    let isEdit = (WorkFlag === 1);
    if(!workID) isEdit = true;

    const dispatch = useDispatch()

    return (
        <TableContainer component={Paper} sx={{mt: 3, maxWidth: 850}} elevation={4}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{minWidth: '16em'}}>Деталь/жидкость</TableCell>
                        <TableCell style={{width: '10em'}}>Цена за единицу</TableCell>
                        <TableCell style={{width: '10em'}}>Количество</TableCell>
                        {showVat &&
                            <TableCell style={{width: '4em'}}>НДС</TableCell>
                        }
                        <TableCell style={{width: '4em'}}>Сумма</TableCell>
                        <TableCell/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {details.map(item => (
                        <MemoizedRow detail={item.job.detail} key={item.jobIndex} index={item.jobIndex}
                                     isEdit={isEdit}/>
                    ))}
                    <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                        <TableCell size={'small'}>
                            {isEdit ? <Button variant={'outlined'}
                                              startIcon={<AddIcon/>}
                                              color={'secondary'}
                                              onClick={() => {
                                                  dispatch(pushDetail())
                                              }}
                                              size={'small'}>
                                Добавить деталь
                            </Button> : null}
                        </TableCell>
                        <TableCell size={'small'}/>
                        <DetailsFooter showVat={showVat}/>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}